module.exports = function() {
  return new Worker(__webpack_public_path__ + "c41f2b90c69370845f53.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./src/services/templateWorker.js
// module id = 2651
// module chunks = 1